import type * as React from 'react'
import { Button as PopcornButton } from '@buffer-mono/popcorn'

import styles from './Button.module.css'

/**
 * AI Assistant Button component with custom purple styling
 */
function Button({
  disabled,
  secondary,
  type,
  align,
  onClick,
  children,
  fullWidth,
  testId,
}: {
  disabled?: boolean
  secondary?: boolean
  align?: 'left' | 'center'
  type?: 'button' | 'submit' | 'reset'
  fullWidth?: boolean
  testId?: string
  onClick: (event: React.MouseEvent) => void
  children: React.ReactNode | JSX.Element
}): JSX.Element {
  const variant = secondary ? 'secondary' : 'primary'
  const className = [
    styles.aiButton,
    styles[variant],
    fullWidth && styles.fullWidth,
    align === 'left' && styles.alignLeft,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <PopcornButton
      variant={variant}
      onClick={onClick}
      disabled={disabled}
      type={type || 'button'}
      className={className}
      data-testid={testId}
    >
      {children}
    </PopcornButton>
  )
}

export { Button }
